import * as firebase from 'firebase';

var firebaseConfig = {
    apiKey: "AIzaSyAohKPHxnFL5ygMVanO9nZD-Dpu5her1wo",
    authDomain: "niyo-global.firebaseapp.com",
    databaseURL: "https://niyo-global.firebaseio.com",
    projectId: "niyo-global",
    storageBucket: "niyo-global.appspot.com",
    messagingSenderId: "888368629251",
    appId: "1:888368629251:web:5616a575cd42c1dfd87036",
    measurementId: "G-DYF16DQ4N7"
  };
  // Initialize Firebase
  if (!firebase.apps.length) firebase.initializeApp(firebaseConfig);

  export default firebase;